export const reportedContentType = [
  { value: '', label: 'Select Type' },
  { value: 'post', label: 'Post' },
  { value: 'comment', label: 'Comment' },
  { value: 'job', label: 'Job' }
]
